import React from "react";

export function PlaneIcon({ className }: { className?: string }) {
  // Extended viewBox: original height 1037.11, back section 567.31, 40% extension = 226.924
  // New height: 1037.11 + 226.924 = 1264.034
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 659.54 1264.03"
      className={className}
    >
      <defs>
        <style>
          {`
            .cls-1 {
              fill: #ededed;
              stroke: #515151;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke-width: 6px;
            }
            .cls-2 {
              fill: #bbb8c9;
            }
          `}
        </style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            d="M656.54,1261.03V466.8c-2-52.79-15.83-206.85-145-339.54C448.18,62.16,381.12,3,329.77,3S211.36,62.16,148,127.26C18.84,260,5.05,414,3,466.8v794.23"
          />
          <path
            className="cls-2"
            d="M342.22,228.22c0-17.79.42-35.6-.17-53.37-.3-8.82,4-10.62,12.45-9.71,73.94,7.92,130.68,42,175.6,93.89,13.2,15.24,12.93,16.12,1.37,32.29C520.82,306.22,510,321,499.46,336c-3,4.3-4.95,6.09-9.93,1-32.92-33.67-75.71-45.8-124.12-45.4-23.19.19-23.19,0-23.19-21.13Z"
          />
          <path
            className="cls-2"
            d="M317.27,228.44c0,16.13-.65,32.28.22,48.36.61,11.23-3.19,15.68-16.26,15-30.05-1.62-59,2.62-86.62,14.36-16.11,6.83-30,15.69-41.62,27.55-6.19,6.31-10.62,6.18-15.7-1.17q-17-24.66-35-48.77c-3.54-4.77-4-8.6-.39-13.5,41.66-56.11,97.3-93.16,172.8-102.82,22.52-2.89,22.6-2.35,22.6,18.85Z"
          />
          <path
            className="cls-2"
            d="M606.48,493.51c-7.28-4.14-4.86-10.32-6.44-15.13C585.2,433.24,564.59,391,525.5,358.2c-4.14-3.48-3.34-5.53-.5-9.21,9.9-12.83,19.59-25.81,28.72-39.1,4.95-7.21,8.06-6.31,12.36.28,15.72,24.11,24.11,50.55,30.56,77.58C604.9,422.36,607.51,457.38,606.48,493.51Z"
          />
          <path
            className="cls-2"
            d="M53,494.69c-1.46-60.54,5.78-117.76,32.41-172a89.91,89.91,0,0,1,8.41-14.17c3.69-4.95,7.51-5.14,11.41.55,8.62,12.62,17.49,25.12,26.72,37.38,3.3,4.38,4.46,7.66,0,11.93-39.35,37.51-63.6,82.05-75.37,132.36C56.43,491.41,55.53,492,53,494.69Z"
          />
        </g>
      </g>
    </svg>
  );
}
